import React from "react";
import ShortlistCandidates from "./components/ShortlistCandidates";
import ShortlistFooter from "./components/ShortlistFooter";
import ShortlistOverview from "./components/ShortlistOverview";
import FeaturedShortlistCandidate from "./components/FeaturedShortlistCandidate";
import RecruiterRepresentative from "./components/RecruiterRepresentative";
import ShortlistOnboarding from "./components/ShortlistOnboarding";
import OrderMainNav from "components/navigations/OrderNavs/OrderMainNav";
import OrderLayerBlueprint from "components/blueprints/OrderLayerBlueprint";

function OrderShortlistPage() {
  return (
    <div className="bg-gray-100 py-2">
      <OrderMainNav />
      <div className="container mx-auto my-6">
        <section className="row px-6 flex">
          <section className="left w-1/2 px-2">
            <ShortlistOverview />
            <FeaturedShortlistCandidate />
          </section>
          <section className="right w-1/2 px-2">
            <RecruiterRepresentative />
            <ShortlistOnboarding />
          </section>
        </section>
        <section className="row">
          <ShortlistCandidates />
        </section>
        <section className="row px-6">
          <ShortlistFooter />
        </section>
      </div>
    </div>
  );
}

export default OrderLayerBlueprint(OrderShortlistPage);
